<template>
    <div  v-loading="dataLoading">
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
            size="medium"
        >
            <div class="page-group-title"><span>基础设置</span></div>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="name" label="活动名称:">
                        <el-input
                            v-model="formData.name"
                            placeholder="请填写活动名称"
                            :maxlength="40"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="datetimerange" label="活动有效期:">
                        <span slot="label">活动有效期: <small>不在时间段内时，用户无法参与活动</small></span>
                        <el-date-picker
                            v-model="formData.datetimerange"
                            type="datetimerange"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                        ></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="poster" label="活动封面:">
                        <image-upload 
                            :url.sync="formData.poster" 
                            :urlFull.sync="formData.poster" 
                            :crop="true"
                            :width="1005"
                            :height="540"
                            ref="posterUpload"
                            class="poster-upload"
                            @onSuccess="handleImageSuccess"
                        >
                        </image-upload>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="datetimerange1" label="活动展示期:">
                        <span slot="label">活动展示期: <small>不在时间段内时，乐迷端不展示活动入口</small></span>
                        <el-date-picker
                            v-model="formData.datetimerange1"
                            type="datetimerange"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="externalLinks" label="外部链接:">
                        <el-input
                            v-model="formData.externalLinks"
                            placeholder="请填写第三方媒体资源，支持https网络地址或iframe形式插入"
                            :maxlength="200"
                            type="textarea"
                            :rows="4"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="activityWord" label="活动口令:">
                        <el-input v-model="formData.activityWord" placeholder="自定义活动口令" type="textarea" show-word-limit maxlength="100"></el-input>
                        <div><span class="color-info">生成口令样例：</span>&&****&&{{formData.command}}</div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="rule" label="活动规则:">
                        <tinymce v-model="formData.rule" :height="400" :toolbar="toolbar" :menubar="false" v-if="reFresh"></tinymce>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="page-group-title"><span>题库设置</span></div>
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="questionList">
                        <span slot="label">题库列表：<el-button type="primary" size="mini" icon="el-icon-plus" @click="$refs.questionEdit.show()">创建问题</el-button></span>
                        <el-table
                            :data="formData.questionList"
                            border
                            style="width: 100%"
                            size="mini"
                        >
                            <el-table-column prop="questionName" label="问题" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="optionList" label="选项">
                                <template slot-scope="{row} = scope">
                                    <div class="opt" v-for="(item,index) in row.optionList" :key="index">{{index + 1}}、{{item.optionName}} <el-tag v-if="item.correct == 1" size="mini" type="success">正确答案</el-tag></div>
                                </template>
                            </el-table-column>
                            <el-table-column fixed="right" label="操作" width="120">
                                <template slot-scope="scope">
                                    <el-button type="text" size="mini" @click="$refs.questionEdit.show(scope.row,scope.$index)">编辑</el-button>
                                    <el-button v-if="formData.questionList.length > 1" type="text" size="mini" @click="delQuestion(scope.$index)" >删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="questionNum" label="出题数：">
                        <el-input-number v-model="formData.questionNum" :min="1" :max="formData.questionList.length || 10000" :precision="0" style="width:100%"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="page-group-title"><span>奖励配置</span></div>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="initCouponRuleId">
                        <span slot="label">初始优惠券: <small>多个ID之间用逗号（中英文皆可）分隔</small></span>
                        <el-input
                            v-model="formData.initCouponRuleId"
                            placeholder="请输入优惠券ID"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="couponRuleId">
                        <span slot="label">最终优惠券: <small>多个ID之间用逗号（中英文皆可）分隔</small></span>
                        <el-input
                            v-model="formData.couponRuleId"
                            placeholder="请输入优惠券ID"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="reviveShareNum" label="复活要求助力次数：">
                        <el-input-number v-model="formData.reviveShareNum" :min="0" :max="100" :precision="0" style="width:100%"></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="reviveNumMax" label="复活次数上限：">
                        <el-input-number v-model="formData.reviveNumMax" :min="1" :max="10000" :precision="0" style="width:100%"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="initJoinNum" label="虚拟参与人数：">
                        <el-input-number v-model="formData.initJoinNum" :min="0" :max="9999999" :precision="0" style="width:100%"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="page-btns-box MT20">
            <!-- <el-button @click="goBack">返 回</el-button> -->
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">提 交</el-button>
        </div>
        <question-edit ref="questionEdit" @onUpdate="updateQuestion"></question-edit>
    </div>
</template>

<script>
import Tinymce from '@/components/Tinymce'; 
import ImageUpload from '@/components/ImageUpload';
import questionEdit from './components/question-edit.vue';
const defaultFormData = {
    name: "",
    datetimerange: null,
    startTime: null,
    endTime: null,
    datetimerange1: null,
    onTime: null,
    offTime: null,
    poster: "",
    externalLinks: "",
    rule: "",
    reviveShareNum: 1,
    reviveNumMax: 100,
    initCouponRuleId: "",
    couponRuleId:"",
    initJoinNum: 0,
    questionList: [],
    questionNum: 3,
    activityWord:"复制查看",
}
export default {
    props:{
        id: {
            type: [Number, String],
            default: ""
        }
    },
    components:{Tinymce, ImageUpload,questionEdit},
    data(){
        return{
            drawerShow: false,
            formData: {
                ...defaultFormData
            },
            dataLoading: false,
            btnLoading: false,
            rules: {
                name: [{ required: true, message: "请填写活动名称" }],
                datetimerange: [{ required: true, message: "请填写活动有效期" }],
                datetimerange1: [{ required: true, message: "请填写活动展示期" }],
                initCouponRuleId: [{ required: true, message: "请填写初始优惠券ID" }],
                couponRuleId: [{ required: true, message: "请填写最终优惠券ID" }],
                reviveShareNum: [{ required: true, message: "请设置复活要求分享次数" }],
                reviveNumMax: [{ required: true, message: "请设置复活次数上限" }],
                poster:  [{ required: true, message: "请上传活动封面" }],
                initJoinNum: [{ required: true, message: "请设置虚拟参与人数" }],
                questionNum: [{ required: true, message: "请设置出题数" }],
                questionList: [{ required: true, message: "请设置题库" }],
            },
            toolbar:['formatselect fontsizeselect | forecolor bold strikethrough | alignleft aligncenter alignright alignjustify | image media'],
            reFresh: false,
            redirect: this.$route.query.redirect || '/promotion/wenda/list',
        }
    },
    mounted(){
        if( this.id ){
            this.getDetailData();
        }else{
            this.formData = {
                ...defaultFormData,
                questionList: []
            }
            this.reFresh = true;
        }
    },
    methods: {
        getDetailData(){
            this.dataLoading = true;
            this.$request({
                url: "/quiz/award/info",
                method: "POST",
                params: {
                    id: this.id
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.formData = {
                        ...defaultFormData,
                        ...result,
                        datetimerange: result.startTime ? [result.startTime,result.endTime] : [],
                        datetimerange1: result.onTime ? [result.onTime,result.offTime] : [],
                    };
                    this.reFresh = true;
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.dataLoading = false;
			});
        },
        //图片上传成功后执行 需要重置海报的水印图
        handleImageSuccess(){
            if(this.formData.poster){
                this.$refs["formData"].clearValidate('poster');
            }
        },
        //删除问题
        delQuestion(index){
            this.$confirm('是否删除该问题？', '提示', {
                confirmButtonText: '确认删除',
                cancelButtonText: '暂不删除',
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(()=> {
                this.formData.questionList = this.formData.questionList.filter((v,i) => index !== i)
            }).catch(()=> {}) 
        },
        //更新问题列表
        updateQuestion(data){
            const _index = data.index !== undefined ? data.index : this.formData.questionList.length
            this.$set(this.formData.questionList, _index, data)

            if(this.formData.questionList.length > 0){
                this.$refs["formData"].clearValidate('questionList');
            }

        },
        //表单提交
        submitForm(){
            this.$refs["formData"].validate( (valid) => {
                if (valid) {
                    if( this.formData.questionNum > this.formData.questionList.length ){
                        this.$message.error('出题数不能大于题库数量');
                        return;
                    }
                    this.btnLoading = true;

                    this.$request({
                        url: '/quiz/award/save',
                        data: {
                            ...this.formData,
                            startTime: this.formData.datetimerange[0],
                            endTime: this.formData.datetimerange[1],
                            onTime: this.formData.datetimerange1[0],
                            offTime: this.formData.datetimerange1[1],
                            initCouponRuleId: this.formData.initCouponRuleId.replaceAll('，',','),
                            couponRuleId: this.formData.couponRuleId.replaceAll('，',',')
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.goBack();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
        
    }
}
</script>

<style lang="scss" scoped>
.opt{
    background: #fbfbfb;
    margin: 3px 0;
    padding: 0 5px;
}
</style>